<template>
  <div class="close-button" @click.prevent="$emit('click')">
    <svg width="21px" height="21px" viewBox="0 0 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Close</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="Visual-Language" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-629.000000, -4504.000000)">
        <g id="Close" transform="translate(629.000000, 4504.000000)" fill="#343A40">
          <path d="M10.1035534,8.68933983 L18.7928932,-4.39648318e-13 L20.2071068,1.41421356 L11.517767,10.1035534 L20.2071068,18.7928932 L18.7928932,20.2071068 L10.1035534,11.517767 L1.41421356,20.2071068 L3.55271368e-14,18.7928932 L8.68933983,10.1035534 L3.55271368e-14,1.41421356 L1.41421356,-4.39648318e-13 L10.1035534,8.68933983 Z"></path>
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
export default {
  name: 'close-button',
}
</script>
<style lang="scss">
.close-button {
  position: absolute;
  right: 0;
  top: 0;
  padding: 30px;
  cursor: pointer;
  @media screen and (max-width: 750px) {
    padding: 20px;
  }
  svg {
    display: block;
  }
}
</style>
